module.exports = __webpack_public_path__ + "img/walk-gray.ba20ceae.svg";